/**
 * Plain-word relationship phrases for publication (founder 2026-09-26 21:16: human terms, not
 * machine). A graph answer says "Finance draws on IT", never "via DRAWS_ON (out, depth 1)".
 * Versioned data, publication-only: the reader catalog never loads it. An unknown kind has no
 * phrase (null) so the caller omits the relation rather than printing the raw kind.
 */
import relationDisplay from './display-names/relation-display.v1.json';

export type AskRelationPhrase = Readonly<{ forward: string; reverse: string }>;
export type AskRelationDisplay = Readonly<{
  version: number;
  phrases: Readonly<Record<string, AskRelationPhrase>>;
}>;
export type AskRelationDirection = 'out' | 'in';

export const ASK_RELATION_DISPLAY: AskRelationDisplay = Object.freeze(
  relationDisplay as AskRelationDisplay
);

/** "draws on" (out) / "is drawn on by" (in) for a relation kind, or null when unknown. */
export function relationDisplayPhrase(
  kind: string,
  direction: AskRelationDirection,
  display: AskRelationDisplay = ASK_RELATION_DISPLAY
): string | null {
  if (!Object.prototype.hasOwnProperty.call(display.phrases, kind)) return null;
  const phrase = display.phrases[kind];
  return direction === 'out' ? phrase.forward : phrase.reverse;
}
